// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"456b9731","189":"6b9edd33","270":"b7d09308","351":"0ab6856c","444":"05e4ce5f","540":"08ac0990","553":"09734f83","767":"8e342949","803":"fb519015","809":"7d0e0df2","917":"cd52d66f","964":"b21d562e","984":"6a147f38"}[chunkId] + ".chunk.js";
};